import $ from 'jquery';
import iframeResizerContent from 'iframe-resizer/js/iframeResizer.contentWindow.min';

export default {

  name: 'image-gallery-block',

  props: {
    block: {}
  },

  data () {
    return {
      iframeScrollTop: 0,
      iframeHeight: 0,
      iframeOffsetTop: 0
    };
  },

  computed: {
    overlayElement: function () {
      return $('.image-gallery-overlay');
    },

    overlayNav: function () {
      return $('.image-gallery-overlay-nav');
    },

    overlayContent: function () {
      return $('.image-gallery-overlay-content');
    }
  },

  methods: {
    showOverlay: function (event) {
      if ('parentIFrame' in window) {
        let navHeight = this.iframeScrollTop - this.iframeOffsetTop + 70;
        this.overlayNav.height(navHeight);
        let overlayHeight = this.iframeHeight - this.iframeScrollTop + this.iframeOffsetTop - 70;
        this.overlayContent.height(overlayHeight);
      }
      this.overlayContent.append("<img src='" + event.target.src + "'>");
      this.overlayElement.addClass('show');
    },

    hideOverlay: function () {
      this.overlayContent.empty();
      this.overlayElement.removeClass('show');
      if ('parentIFrame' in window) {
        let proxy = this;
        setTimeout(function () {
          proxy.overlayNav.height(70);
          proxy.overlayContent.height(200);
        }, 500);
      }
    },

    getPageInfoIframe: function (iframeObject) {
      this.iframeScrollTop = iframeObject.scrollTop;
      this.iframeHeight = iframeObject.iframeHeight;
      this.iframeOffsetTop = iframeObject.offsetTop;
    },

    resizeAllGridItems: function () {
      let grid = document.getElementsByClassName('image-gallery-grid')[0];
      let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
      let allItems = document.getElementsByClassName('image-gallery-item');
      for (let x = 0; x < allItems.length; x++) {
        let rowSpan = Math.ceil((allItems[x].querySelector('.image-gallery-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
        allItems[x].style.gridRowEnd = 'span ' + rowSpan;
      }
    },

    resizeGridItemEvent: function (event) {
      let item = event.target.closest('.image-gallery-item');
      let grid = document.getElementsByClassName('image-gallery-grid')[0];
      let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
      let rowSpan = Math.ceil((item.querySelector('.image-gallery-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
      item.style.gridRowEnd = 'span ' + rowSpan;
    }

  },

  mounted () {
    window.addEventListener('resize', this.resizeAllGridItems);
    if ('parentIFrame' in window) {
      parentIFrame.getPageInfo(
        (pageInfo) => this.getPageInfoIframe(pageInfo)
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/imageGalleryBlock/ImageGalleryBlock.js